import { categories } from "@/mocks/resources";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Categories() {
  return (
    <section id="categories" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="资源分类"
          icon="ri-layout-grid-line"
          title="色虎资源分类浏览"
          desc="站点把视频、写真与图片按六个方向归档。每个分类都标注了当前收录数量与内容侧重，便于按兴趣方向快速定位到想看的资源类型。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.name === "写真合集" ? "#photobooks" : cat.name === "视频资源" ? "#videos" : "#gallery"}
              className="group flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-2xl">
                <i className={cat.icon}></i>
              </span>
              <div className="flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">
                    {cat.name}
                  </h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
                    {cat.count} 项
                  </span>
                </div>
                <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">
                  {cat.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}